var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.$style.root},[_c('div',{ref:"content",class:_vm.$style.content}),(_vm.isLoading)?_c('div',{class:_vm.$style.loading},[_c('div',{class:_vm.$style.loader})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }